import { buildModelManager } from "../builder.js";
const DefaultShopifyShopSelection = {
  __typename: true,
  id: true,
  state: true,
  address1: true,
  address2: true,
  alerts: true,
  billingAddress: true,
  checkoutApiSupported: true,
  city: true,
  confirmationUrl: true,
  cookieConsentLevel: true,
  countriesInShippingZones: true,
  country: true,
  countryCode: true,
  countryName: true,
  countyTaxes: true,
  createdAt: true,
  currency: true,
  currencyBackup: true,
  currencyFormats: true,
  customerAccounts: true,
  customerAccountsV2: true,
  customerEmail: true,
  description: true,
  disabledWebhooks: true,
  domain: true,
  eligibleForCardReaderGiveaway: true,
  eligibleForPayments: true,
  email: true,
  enabledPresentmentCurrencies: true,
  enabledPresentmentCurrenciesBackup: true,
  finances: true,
  forceSsl: true,
  googleAppsDomain: true,
  googleAppsLoginEnabled: true,
  grantedScopes: true,
  hasDiscounts: true,
  hasGiftCards: true,
  hasStorefront: true,
  ianaTimezone: true,
  installedViaApiKey: true,
  latitude: true,
  longitude: true,
  marketingSmsContentEnabledAtCheckout: true,
  moneyFormat: true,
  moneyInEmailsFormat: true,
  moneyWithCurrencyFormat: true,
  moneyWithCurrencyInEmailsFormat: true,
  multiLocationEnabled: true,
  myshopifyDomain: true,
  name: true,
  orderNumberFormatPrefix: true,
  orderNumberFormatSuffix: true,
  passwordEnabled: true,
  phone: true,
  planActive: true,
  planAmount: true,
  planCurrency: true,
  planDisplayName: true,
  planId: true,
  planName: true,
  preLaunchEnabled: true,
  primaryLocale: true,
  primaryLocationId: true,
  province: true,
  provinceCode: true,
  registeredWebhooks: true,
  requiresExtraPaymentsAgreement: true,
  resourceLimits: true,
  richTextEditorUrl: true,
  setupRequired: true,
  shipsToCountries: true,
  shopOwner: true,
  shopifyCreatedAt: true,
  shopifyUpdatedAt: true,
  source: true,
  subscriptionId: true,
  taxShipping: true,
  taxesIncluded: true,
  timezone: true,
  timezoneAbbreviation: true,
  timezoneOffset: true,
  timezoneOffsetMinutes: true,
  transactionalSmsDisabled: true,
  unitSystem: true,
  updatedAt: true,
  url: true,
  weightUnit: true,
  weightUnitBackup: true,
  zipCode: true
};
const modelApiIdentifier = "shopifyShop";
const pluralModelApiIdentifier = "shopifyShops";
;
;
;
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultShopifyShopSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultShopifyShopSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyShopSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyShopSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyShopSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultShopifyShopSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultShopifyShopSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "updateShopifyShop",
    operationReturnType: "UpdateShopifyShop",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      shopifyShop: { required: false, type: "UpdateShopifyShopInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultShopifyShopSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateShopifyShops",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateShopifyShopsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultShopifyShopSelection
  },
  {
    type: "action",
    operationName: "enableSubscriptionShopifyShop",
    operationReturnType: "EnableSubscriptionShopifyShop",
    functionName: "enableSubscription",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: DefaultShopifyShopSelection
  },
  {
    type: "action",
    operationName: "bulkEnableSubscriptionShopifyShops",
    functionName: "bulkEnableSubscription",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "enableSubscription",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: DefaultShopifyShopSelection
  },
  {
    type: "action",
    operationName: "payFeesShopifyShop",
    operationReturnType: "PayFeesShopifyShop",
    functionName: "payFees",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      shopifyShop: { required: false, type: "PayFeesShopifyShopInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultShopifyShopSelection
  },
  {
    type: "action",
    operationName: "bulkPayFeesShopifyShops",
    functionName: "bulkPayFees",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "payFees",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkPayFeesShopifyShopsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultShopifyShopSelection
  },
  {
    type: "action",
    operationName: "subscribeShopifyShop",
    operationReturnType: "SubscribeShopifyShop",
    functionName: "subscribe",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      planId: { required: false, type: "String" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["planId"],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: DefaultShopifyShopSelection
  },
  {
    type: "action",
    operationName: "bulkSubscribeShopifyShops",
    functionName: "bulkSubscribe",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "subscribe",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkSubscribeShopifyShopsInput!]" }
    },
    paramOnlyVariables: ["planId"],
    defaultSelection: DefaultShopifyShopSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "shopifyShopGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
operations.push(...[
  "create",
  "bulkCreate",
  "reinstall",
  "bulkReinstall",
  "uninstall",
  "bulkUninstall"
].map((operation) => ({
  type: "stubbedAction",
  functionName: operation,
  errorMessage: `The action ${operation} on model shopifyShop does not have an api trigger and cannot be called from this api client. If you are the developer of this application and want api clients to call this action add an api trigger to the action. For more information see: https://docs.gadget.dev/guides/actions/triggers`,
  operationName: "",
  dataPath: "",
  actionApiIdentifier: operation,
  modelApiIdentifier,
  variables: {},
  reason: "MissingApiTrigger"
})));
const ShopifyShopManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultShopifyShopSelection,
  operations
);
export {
  DefaultShopifyShopSelection,
  ShopifyShopManager
};
//# sourceMappingURL=ShopifyShop.js.map
